// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610150505/js/" + chunkId + "." + {"44":"396afaee","225":"f9ece721","481":"4600770a","486":"0ea5561d","770":"a45fb4bf"}[chunkId] + ".0.25989543200068166.chunk.js";
};